import {css, StyleSheet} from 'aphrodite';
import React from 'react';
import ShowMoreText from 'react-show-more-text';

import * as analytics from 'analytics/Analytics';
import {ActionOrigin, WORKFLOWS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {FONT_PROXIMA_13} from 'styles/FontConstants';
import * as Colors from 'ui-library/Colors';
import UrlAwareText from 'ui-library/UrlAwareText';

// Exported for test only
export enum AdjustmentType {
  COLLAPSED = 'COLLAPSED',
  EXPANDED = 'EXPANDED',
}

export interface TaskGroupInstructionProps {
  lines: number;
  textValue: string | null;
  actionOrigin: ActionOrigin;
  clientOrigin: ProcessClientOrigin;
}

export function TaskGroupInstructions(props: TaskGroupInstructionProps): JSX.Element {
  return (
    <div>
      {props.textValue ? (
        <ShowMoreText
          lines={props.lines}
          more={
            <span>
              <br />
              See more
            </span>
          }
          less={
            <span>
              <br />
              See less
            </span>
          }
          onClick={(expanded: boolean) => {
            analytics.trackEvent(WORKFLOWS_ANALYTICS_ACTIONS.ADJUSTED_VIEW_TASK_GROUP_INSTRUCTIONS, {
              adjustment_type: expanded ? AdjustmentType.EXPANDED : AdjustmentType.COLLAPSED,
              action_origin: props.actionOrigin,
              process_client_origin: props.clientOrigin,
            });
          }}
        >
          <UrlAwareText textValue={props.textValue} breakNewLines={true} />
        </ShowMoreText>
      ) : (
        <span className={css(styles.noneText)}>None</span>
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  noneText: {
    text: FONT_PROXIMA_13,
    color: Colors.GRAY_DARKER,
    lineHeight: '16px',
  },
});
